export default __webpack_public_path__ + "static/media/meal-heavy.5e422a86.svg";